angular.module('graph').controller('ph-modal', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast',
    function(
        $scope, $root, $core, $broadcast
    ) {
        $scope.show      = false;

        $scope.$on('ph-modal-show', function($event, $data) {

            $('.ph-modal-content').html($data);

            $scope.open();
        });

        $scope.open = function() {
            $scope.show = true;

            angular.element(
                '#modal'
            ).addClass(
                'show'
            );
        };

        $scope.close = function() {
            $scope.show = false;

            angular.element(
                '#modal'
            ).removeClass(
                'show'
            )
        };

        angular.element('body').click(function(e) {
            if (angular.element(e.target).hasClass('modal-window') && $scope.show === true) {
                angular.element('#modal .close').trigger('click');

                e.stopPropagation();
            }
        });
    }
]);

angular.module('graph').controller('ph-modal-invite', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast',
    function(
        $scope, $root, $core, $broadcast
    ) {
        $scope.show          = false;

        $scope.$term         = [];

        $scope.$button       = [];

        $scope.$countFriends = 0;

        $scope.$on('ph-modal-invite', function($event, $data) {

            $scope.$term = $data;

            if ($scope.$term.length === 0) {
                $core.get('/xhr/me/friends').then(function($response) {
                    $scope.$countFriends = $response.data.items;
                });
            }

            for(var index = 0; index < $scope.$term.length; index++) {
                var item = $scope.$term[index];

                $scope.$button[item.id] = false;
            }

            $scope.open();
        });

        $scope.$on('ph-modal-invite-done', function($event, key, $data) {
            $scope.$term[key] = $data;
        });

        $scope.invite = function (key, $profile) {
            $scope.$button[$profile.id] = true;
            $root.$broadcast('ph-request-entry-invite', key, $profile);
        };

        $scope.open = function() {
            $scope.show = true;

            angular.element(
                '#modal'
            ).addClass(
                'show'
            );
        };

        $scope.close = function() {
            $scope.show = false;

            angular.element(
                '#modal'
            ).removeClass(
                'show'
            )
        };

        angular.element('body').click(function(e) {
            if (angular.element(e.target).hasClass('modal-window') && $scope.show === true) {
                angular.element('#modal .close').trigger('click');

                e.stopPropagation();
            }
        });
    }
]);